import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { messages } from './ContactUs.i18n';
import Header from '../../components/Header/Header';
import {
  loadContactInstructions,
  loadContacts,
} from '../../redux/modules/contact-us/middleware';

class ContactUs extends React.Component {
  UNSAFE_componentWillMount() {
    const { facilityId, languageCode, dispatch } = this.props;
    if (facilityId) {
      dispatch(loadContactInstructions(facilityId, languageCode));
      dispatch(loadContacts(facilityId));
    }
  }

  loadHtml(contant) {
    const markup = () => ({ __html: contant });
    return (
      <div dangerouslySetInnerHTML={markup()} />
    );
  }

  render() {
    const { contactUs } = this.props;
    return (
      <div id="contact-us-content">
        <div className="row">
          <div className="col-xs-12">
            <Header
              headerTitle={ <FormattedMessage { ...messages.page.title } /> }
              data-qa-item="pageHeader"
            />
            <div className="spacer tiny"></div>
            {
              contactUs.instructions ?
              <div>
                <div className="row">
                  <div className="col-xs-12 col-md-6" data-qa-container="contactUsInstructions">
                    { this.loadHtml(contactUs.instructions) }
                  </div>
                </div>
                <div className="spacer medium"></div>
              </div> :
                null
            }
            {
              contactUs.contacts.length ?
              <div className="row">
                <div className="col-xs-12 col-md-6">
                  <table className="table" data-qa-container="contactUsContacts">
                    <thead>
                      <tr>
                        <th><FormattedMessage { ...messages.columns.name } /></th>
                        <th><FormattedMessage { ...messages.columns.contactInfo } /></th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        contactUs.contacts.sort((a, b) => a.sortOrder - b.sortOrder).map((contact, index) => (
                          <tr key={index}>
                            <td>{contact.contactName}</td>
                            <td>
                              <div>{contact.address1}</div>
                              <div>{contact.address2}</div>
                              <div>{contact.city}</div>
                              <div>{contact.state}</div>
                              <div>{contact.zipCode}</div>
                              <div>{contact.country}</div>
                              {
                                contact.phone ?
                                <div>
                                  <FormattedMessage { ...messages.contact.phone } values={{ phone: contact.phone }} />
                                </div> :
                                  null
                              }
                              {
                                contact.fax ?
                                <div>
                                  <FormattedMessage { ...messages.contact.fax } values={{ fax: contact.fax }} />
                                </div> :
                                  null
                              }
                              {
                                contact.email ?
                                <div>
                                  <a href={ 'mailto:' + contact.email }>
                                    { contact.email }
                                  </a>
                                </div> :
                                  null
                              }
                            </td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </div>
              </div> :
                null
            }
          </div>
        </div>
      </div>
    );
  }
}

ContactUs.propTypes = {
  dispatch: PropTypes.func,
  contactUs: PropTypes.object,
  facilityId: PropTypes.number,
  languageCode: PropTypes.string,
};

const mapStateToProps = (state) => ({
  contactUs: state.contactUs,
  facilityId: state.facility.facilityId,
  languageCode: state.language.languageCode,
});


export default connect(mapStateToProps)(ContactUs);